exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fab.fa-bitcoin:before{content:\"\\F379\"}.far.fa-calendar:before,.fas.fa-calendar:before{content:\"\\F133\"}.far.fa-clipboard:before,.fas.fa-clipboard:before{content:\"\\F328\"}.fab.fa-facebook-f:before{content:\"\\F39E\"}.fab.fa-google-plus:before{content:\"\\F2B3\"}.fas.fa-hotel:before{content:\"\\F594\"}.fab.fa-linkedin:before{content:\"\\F08C\"}.fas.fa-reply:before{content:\"\\F3E5\"}.fas.fa-thermometer:before{content:\"\\F491\"}.fab.fa-vimeo:before{content:\"\\F40A\"}.far.fa-window-close:before,.fas.fa-window-close:before{content:\"\\F410\"}.fab.fa-youtube-square:before{content:\"\\F431\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/assets/fonts/fontawesome5-overrides.min.css
// module id = 64
// module chunks = 0